import { useNavigate } from "react-router";
import secureStorage from '@src/config/encrypt';
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getMasterConfigID } from "@store/slices/common";
import { useLanguage } from "@src/context/LanguageContext";


interface Props {
  masterConfig: Record<string, any>;
  setLoading: (loading: boolean) => void;
}

const CreateApplicationSection = (props: Props) => {

  const [vehicleType, setVehicleType] = useState<any>([]);
  const { masterConfig,setLoading } = props;

  const dispatch:any = useDispatch();

  const navigate = useNavigate();
  const {translations} = useLanguage();

  const vehicleTypes = [...(masterConfig?.vehicle_type || [])].sort(
    (a, b) => a.category_id - b.category_id
  );
  const fetchMasterConfig = async () => {
    setLoading(true);
    try {
      if(vehicleTypes?.length > 0)  return setVehicleType(vehicleTypes);
        const res: any = await dispatch(getMasterConfigID());
        if (res?.status==200) {
          setVehicleType(res?.data?.vehicle_type);
        }
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch master config:", error);
      }
  }

  useEffect(() => {
    fetchMasterConfig();
  }, []);

  const handleClick = (item:any) => {
    secureStorage.setItem('vehicle_type', item);
    navigate('/create-insurance-policy?step=vehicle')
  };

  return (
    <div className="">
      <div className="create-app-card">
        <h2 className="card-title">{translations?.DASHBOARD?.CREATE_APPLICATION}</h2>

        <div className="vehicle-options">
          {vehicleType?.map((item: any) => (
            <button
              key={item.value}
              className="vehicle-btn"
              onClick={()=>handleClick(item)}
            >
              <span className="icon">
                <img
                  src={item.icon || "/images/car.png"}
                  alt={item.label}
                />
              </span>
              <span className="item-label">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreateApplicationSection;
